import { combineReducers } from 'redux';
import {
  createReducer,
  defaultListInitialState,
  createRequestReducer
} from 'utils';

import {
  GET_SEARCH_RESULTS,
  DATA_CLEAR_SEARCH_RESULTS,
  GET_SEARCH_RESULTS_MAP,
  DATA_CLEAR_SEARCH_RESULTS_MAP,
  DATA_SEARCH_TOGGLE_BIKE_TYPE,
  DATA_SEARCH_INCLUDE_BIKE_TYPES,
  DATA_SEARCH_SET_BOOKING_PERIOD,
  DATA_SEARCH_SET_SEARCH_PARAMS,
  DATA_SEARCH_INIT_SEARCH
} from '../constants';

import {
  Include,
  Exclude,
  toggle
} from 'utils/SelectionModes';


const searchResultsInitialState = defaultListInitialState();
const searchResults = createReducer(searchResultsInitialState, {
  [GET_SEARCH_RESULTS]: (state, action) => createRequestReducer(state, action, {
    SEND: (state, action) => Object.assign({}, state, {
      isFetching: true,
      error: null,
      query: action.meta.queryParams
    }),

    SUCCESS: (state, action) =>
      Object.assign({}, state, {
        isFetching: false,
        error: null,
        items: state.items ?
          Object.assign({}, action.response, {
            results: state.items.results.concat(action.response.results)
          }) :
          action.response
      }),

    FAIL: (state, action) =>
      Object.assign({}, state, {
        isFetching: false,
        error: action.error
      })
  }),
  [DATA_CLEAR_SEARCH_RESULTS]: () => searchResultsInitialState
});

const searchResultsMapInitialState = Object.assign({}, defaultListInitialState(), {
  queryString: null
});

const searchResultsMap = createReducer(searchResultsMapInitialState, {
  [GET_SEARCH_RESULTS_MAP]: (state, action) => createRequestReducer(state, action, {
    SEND: (state, action) =>
      Object.assign({}, state, {
        isFetching: true,
        error: null,
        queryString: action.queryString
      }),

    SUCCESS: (state, action) => {
      if (action.queryString === state.queryString) {
        return Object.assign({}, state, {
          items: action.response,
          isFetching: false,
          error: null,
          queryString: null
        });
      } else {
        return state;
      }
    },

    FAIL: (state, action) =>
      Object.assign({}, state, {
        isFetching: false,
        error: action.error,
        queryString: null
      })
  }),
  [DATA_CLEAR_SEARCH_RESULTS_MAP]: () => searchResultsInitialState
});

const createInitialSearchQueryState = () => {
  return {
    bikeTypes: {
      mode: `${Exclude}`,
      ids: []
    }
  };
};

export const searchQuery = createReducer(createInitialSearchQueryState(), {
  [DATA_SEARCH_INIT_SEARCH]: (state, action) => {
    const {
      period,
      params,
      bikeTypes
    } = action.payload;

    return {
      ...period,
      bikeTypes: bikeTypes ? ({
        mode: `${Include}`,
        ids: bikeTypes
      }) : state.bikeTypes,
      params
    };
  },
  [DATA_SEARCH_TOGGLE_BIKE_TYPE]: (state, action) => {
    const {
      bikeType
    } = action.payload;

    const {
      mode,
      ids
    } = state.bikeTypes;

    return {
      ...state,
      bikeTypes: {
        mode,
        ids: toggle(bikeType, ids)
      }
    };
  },
  [DATA_SEARCH_INCLUDE_BIKE_TYPES]: (state, action) => {
    const {
      bikeTypes
    } = action.payload;

    return {
      ...state,
      bikeTypes: {
        mode: `${Include}`,
        ids: [...bikeTypes]
      }
    };
  },
  [DATA_SEARCH_SET_BOOKING_PERIOD]: (state, action) => {
    return Object.assign({}, state, action.payload);
  },
  [DATA_SEARCH_SET_SEARCH_PARAMS]: (state, action) => {
    return { ...state, params: { ...action.payload } };
  }
});

export default combineReducers({
  searchResults,
  searchResultsMap,
  searchQuery
});



// WEBPACK FOOTER //
// ./src/reducers/search.js